"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorAdvancedIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.8 17 9 19H7l.763-2zm-.893-3 1.907-5h2.372l1.907 5h-1.926L12 10.5 10.833 14zm7.33 3L17 19h-2l-.8-2zM5 15h14v1H5zM18 5v1h-2v2h2v1h-3V5zm0 1h1v2h-1z"/></svg>`
}, props));
EditorAdvancedIcon.displayName = 'EditorAdvancedIcon';
var _default = exports.default = EditorAdvancedIcon;